<template>
  <i-input v-model="string" :rows="10" type="textarea" />
</template>

<script>
  import { replaceNotNumber } from '@shared/helpers/replace';

  export default {
    props: {
      value: {
        type: Array,
        default: () => []
      }
    },

    computed: {
      string: {
        get: function() {
          return this.value.map(i => replaceNotNumber(i)).join('\n');
        },
        set: function(val) {
          const p = `${val}`.split('\n').map(i => replaceNotNumber(i));
          this.$emit('input', p);
        }
      }
    }
  };
</script>
